import React from "react";
import { Box, Heading, Text, Image, Container, SimpleGrid, VStack, useColorModeValue } from "@chakra-ui/react";

const ProjectCard = ({ title, description, imageSrc }) => {
  return (
    <VStack
      align={"flex-start"}
      bg={useColorModeValue("white", "gray.700")}
      p={5}
      borderRadius="md"
      boxShadow="md"
      spacing={3}
    >
      <Image src={imageSrc} alt={title} borderRadius="md" />
      <Heading as="h3" size="md">
        {title}
      </Heading>
      <Text>{description}</Text>
    </VStack>
  );
};

function Portfolio() {
  const projects = [
    {
      title: "Residential Solar Installation",
      description: "5kW system for a family home in California.",
      imageSrc: "/path-to-project1-image.jpg",
    },
    {
      title: "Commercial Solar Project",
      description: "100kW system for a manufacturing facility in Texas.",
      imageSrc: "/path-to-project2-image.jpg",
    },
    {
      title: "Solar Farm",
      description: "5MW utility-scale solar farm in Arizona.",
      imageSrc: "/path-to-project3-image.jpg",
    },
    {
      title: "Off-Grid Solar System",
      description: "10kW off-grid system for a remote cabin in Colorado.",
      imageSrc: "/path-to-project4-image.jpg",
    },
  ];

  return (
    <Box py={20}>
      <Container maxW={"container.xl"}>
        <Heading as="h1" size="2xl" mb={10} textAlign="center">
          Our Portfolio
        </Heading>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
          {projects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}

export default Portfolio;
